"use client";
import { Icon } from "@iconify/react";
import "./style.css";

interface IProps {
  icon: string;
  label?: string;
  width?: number | string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  tooltip?: string;
  tooltipPosition?: "top" | "right" | "left" | "bottom";
}

const AppIcon = ({ icon, label, width = 15, className, style, onClick, tooltip, tooltipPosition = "top" }: IProps) => {
  return (
    <div
      className={`app-icon ${tooltip ? "app-icon-with-tooltip" : ""} ${className || ""}`}
      style={{ display: "inline-flex", alignItems: "center", ...style }}
      onClick={onClick}
    >
      <Icon icon={icon} width={width} />
      {label && (
        <span style={{ marginLeft: 6, display: "inline-block", verticalAlign: "middle" }}>
          {label}
        </span>
      )}
      {tooltip && <span className={`app-icon-tooltip app-icon-tooltip-${tooltipPosition}`}>{tooltip}</span>}
    </div>
  );
};

export default AppIcon;
